import { PATTERN_SAMPLE_MAX_PAGES } from './enum';

// リファラル招待関連メッセージ
export const referralMessages = {
  // ダイアログ
  dialogTitle: 'お知り合いの企業を招待',
  inviteLinkLabel: '招待リンク',
  createAndCopyButton: '作成してURLをコピー',
  cardTitle: 'お知り合いの企業をご紹介ください',
  createLinkButton: '招待リンクを作成',
  menuLabel: '友達を招待',

  // スナックバー
  linkCopied:
    '招待リンクをコピーしました。メールやチャットに貼り付けて、知り合いの企業の方にお送りください。',
  createFailed: '招待リンクの作成に失敗しました。',
  copyFailed: 'コピーに失敗しました。',

  // バナー
  bannerTitle: (companyName: string): string => `${companyName}様からのご紹介です`,
  bannerText: '約100枚のOCR読取をお試しいただける、5,000円分のクレジットを差し上げます。',
} as const;

// クーポン関連メッセージ
export const couponMessages = {
  // ダイアログ
  dialogTitle: 'クーポン作成',
  codeLabel: 'クーポンコード',
  noteLabel: 'メモ（任意）',
  notePlaceholder: '例: PO名刺用',
  codeHelperText: '自動生成されます。変更も可能です。',
  rewardDescription: '特典: 10,000円分 / 有効期間: 90日',
  menuLabel: 'クーポン作成',

  // ボタンラベル
  createAndCopyButton: '作成してURLをコピー',
  updateAndCopyButton: '更新してURLをコピー',

  // スナックバー
  created: (code: string): string =>
    `クーポンリンクをコピーしました（コード: ${code}）。名刺やカードに印刷してご利用ください。`,
  updated: (code: string): string =>
    `クーポンを更新してリンクをコピーしました（コード: ${code}）。`,
  createFailed: 'クーポンの作成に失敗しました。',
  updateFailed: 'クーポンの更新に失敗しました。',

  // バナー
  bannerTitle: 'クーポンが適用されます',
  bannerText: (amount: number, pages: number): string =>
    `約${pages}枚のOCR読取をお試しいただける、${amount.toLocaleString()}円分のクレジットを差し上げます。`,
} as const;

// バージョン更新通知メッセージ
export const versionUpdateMessages = {
  newVersionAvailable: '新しいバージョンがあります。エラーが出ている場合は再読み込みしてください',
  reloadButton: '再読み込み',
} as const;

// グループ関連メッセージ
export const groupMessages = {
  // 上限超過（件数は groupLimit の定数を渡す）
  companyLimitReached: (max: number): string => `グループは1企業あたり最大${max}件までです`,
  userLimitReached: (max: number): string => `1ユーザーが所属できるグループは最大${max}件までです`,
} as const;

// 読取パターン作成関連メッセージ
export const patternMessages = {
  // バリデーション・エラー
  noFileSelected: '読取ファイルが選択されていません。',
  noFileSelectedReturnToFirstStep:
    '読取ファイルが選択されていません。最初のSTEPに戻って選択してください。',
  // サンプル合計ページ上限（#2961）
  sampleTruncatedToMaxPages: `サンプルは合計${PATTERN_SAMPLE_MAX_PAGES}ページまでです。${PATTERN_SAMPLE_MAX_PAGES + 1}ページ目以降は自動的に除外されました。`,
  // 編集時、既存サンプルが既に上限に達していて新規を追加できない場合（#2961）
  sampleAlreadyMaxPages: `サンプルは既に上限の${PATTERN_SAMPLE_MAX_PAGES}ページです。差し替える場合は既存のファイルを削除してください。`,
  // 編集時にAI読取を再実行する際の確認（#3147）
  aiReadOverwriteTitle: '項目をAIで読み取り直しますか。',
  aiReadOverwriteMessage:
    '現在の項目設定はすべて破棄され、AIが読み取った項目に置き換わります。これまでに読み取ったデータは新しい項目に引き継がれず、表示されなくなります。',
  aiReadOverwriteNote:
    '※項目名や型を個別に直したいだけの場合は、この操作は不要です。項目設定の画面で直接編集してください。',
  aiReadOverwriteWarningOnEdit:
    '編集中の読取パターンで「項目をAIで読み取る」を実行すると、現在の項目設定はすべてAIの読取結果に置き換わり、これまでに読み取ったデータは表示されなくなります。項目を個別に直す場合は「項目設定」の画面で編集してください。',
  // 編集時に「リセットして手動入力」を実行する際の確認（#3147）
  itemResetTitle: '項目をリセットして手動入力に切り替えますか。',
  itemResetMessage:
    '現在の項目設定はすべて削除され、空の項目が1件だけの状態になります。これまでに読み取ったデータは表示されなくなります。',
  itemResetNote:
    '※一部の項目だけ追加・削除したい場合は、この操作は不要です。項目設定の画面で直接編集してください。',
} as const;
